<template>
  <div id="app" >
    <div class="header">
      <div class="nav warp">
        <div class="title">E识别</div>
        <button v-if="user==null" @click="login" class="login-btn" style="margin-top:6px;">
          登录/注册
        </button>
        <button v-if="user!=null" @click="logout" class="login-btn" style="margin-top:10px;margin-left:10px">
          退出
        </button>
        <div v-if="user!=null" class="photo" style="float:right;margin-top:-13px">
          <!-- <img :src="user!=null?user.img:'/static/images/my_user.jpg'"/> -->
          <a href="/my?page=searching" :title="user.userName!=null && user.userName!=''?user.userName:user.phone">
            <el-avatar :size="60" :src="user!=null?user.img:''">
              <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"/>
            </el-avatar>
          </a>
        </div> 
        <ul class="cnt">
          <li><a href="/">首页</a></li>
          <li><a href="#" @click="dialogTableVisible=true">监测操作指引</a></li>
          <li><a href="/search">图片识别</a></li>
          <li><a href="/store">充值中心</a></li>
          <li><a href="/my?page=searching">个人中心</a></li>
        </ul>
        <div class="clear-float"></div>
      </div>
      <div class="desc warp">
        <div class="d1">E识别-图片比对监测平台</div>
        <div class="d2">图片检测方便快捷。24小时对您的创作成果定向全网监测 ，</div>
        <div class="d3">随时查看是否有抄袭和盗用您的作品。</div>
         <button class="help-btn" @click="goSearch">图片识别</button>
      </div>

      <div class="product warp">
        <ul>
          <li style="margin-right:52px">
            <img src="/static/images/index_i1.png"/>
            <div>专业图形识别技术</div>
          </li>
          <li style="margin-right:52px">
            <img src="/static/images/index_i2.png"/>
            <div>智能定向全网监测搜证</div>
          </li>
          <li style="margin-right:52px">
            <img src="/static/images/index_i3.png"/>
            <div>自动生成监测报告</div>
          </li>
          <li>
            <img src="/static/images/index_i4.png"/>
            <div>快速对接维权服务</div>
          </li>

        </ul>
      </div>
     
    </div>
    <div class="line"></div>
    <h2 class="warp" style="margin-top:84px">更多服务</h2>
    <div class="platform warp">
      <a class="efb" href="#" @click="showSomeThing(1)" style="color:rgb(255,255,255)" >
        <div class="title">E防标原创版权保护平台 </div>
        <div class="des">1分钟作品快速备案</div>
        <div class="des">保护您的创作成果</div>
      </a>
      <div class="ezl" @click="showSomeThing(2)">
        <div class="title">E证链存取证平台</div>
        <div class="des">取证存证快捷方便</div>
        <div class="des">利用时间戳区块链技术安全可靠</div>
      </div>
      <div class="clear-float"></div>
    </div>
    
    <div class="platform warp" style="margin-top:23px">
      <div class="esb">
        <div class="title">E识别版权服务监测系列</div>
        <ul class="" style="margin-top:59px">
          <a href="http://www.dmid.com.cn/" target="view_window" style="border-right:1px #fff solid;color:rgb(255,255,255)">E识别图片比对监测平台</a>
          <li style="border-right:1px #fff solid;">E识别文字监测平台</li>
          <a href="http://www.dmid-china.com/" target="view_window" style="border-right:1px #fff solid;color:rgb(255,255,255)">E识别音频ID监测平台</a>
          <li>E识别视频监测平台</li>
        </ul>
      </div>
    </div>
    <div class="others">
      我们并且提供线下的 版权登记、商标申请、专利申请、国家知识产权管理体系认证（贯标）、国家高新技术企业认定、知识产权资助申报、版权维权调查、维权证据固化、知识产权纠纷调解、知识产权诉讼代理、网络平台维权，详情可电话咨询。
    </div>

    <div class="bottom">
        <a href="https://beian.miit.gov.cn/">粤ICP备13019950号</a>
    </div>

    <el-dialog title="操作指引" 
    :visible.sync="dialogTableVisible"
    width="992px"
    >
    <el-carousel :initial-index="0" height="400px">
      <el-carousel-item v-for="item in 6" :key="item">
        <img :src="'../../static/images/'+item+'.png'" class="img"/>
        <!-- <h3 class="small"><img :src="'../../static/images/'+item+'.png'"/></h3> -->
      </el-carousel-item>
    </el-carousel>
    </el-dialog>

    <el-dialog 
    :title="someThingTitle" 
    :visible.sync="someThing"
    :lock-scroll="false"
    width="992px"
    >
      <img class="img" :src="imgSrc"/>
    </el-dialog>
  </div>
</template>
<script>
import {logoutApi,userInfoApi} from '@/service/allApi'
export default {
  data(){
    return {
      user:null,
      dialogTableVisible:false,
      someThing:false,
      someThingTitle:'E防标简介',
      imgSrc:'https://www.efangbiao.com/img/public/about_us_3.png'
    }
  },
  created: function(){
    var that = this
   
   //获取登录信息
    that.userInfoApi();
    
  },
  methods:{
    login(){
      this.$router.push("/login")
    },
    async logout(){
      await logoutApi()
      localStorage.removeItem("user")
      this.$router.push("/login")
    },
    userInfoApi(){
       userInfoApi().then((res2)=>{
          const code = res2.data.code
          if(code == 100){
            if(res2.data.data!=null){
              this.user = res2.data.data
              localStorage.setItem("user",JSON.stringify(res2.data.data))
            }else{
                localStorage.clear();
            }
          }
        })
    },
    goSearch(){
      this.$router.push("/search")
    },
    showSomeThing(item){
      if(item==1){
        this.someThingTitle='E防标简介',
        this.imgSrc='https://www.efangbiao.com/img/public/about_us_3.png'
      }else if(item == 2){
        this.someThingTitle='E证链存取证平台简介',
        this.imgSrc='https://www.efangbiao.com/img/public/about_us_3.png'
      }else{
        this.someThingTitle='E识别版权服务监测系列简介',
        this.imgSrc='https://www.efangbiao.com/img/public/about_us_3.png'
      }
      this.someThing = true
    }
  }

}
</script>
<style scoped>

.img{
  width: 100%;
  height: 89%;
}

.el-carousel__item h3 {
  color: #000000;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
a{
  text-decoration: none;
}
.clear-float{
  clear: both;
}
.warp {
  margin: 0 auto;
  width: 1227px;
}
ul{
  padding: 0px;
  margin: 0px;
}
ul li{
  list-style-type:none;
}
.header{
    background: url("/static/images/index_bg.png");
    background-position:top center;
    background-repeat: no-repeat;
    min-width:1227px;
    background-size:100% 100%;
    height:550px;
    color: white;
}
.header .nav{
  padding-top:27px;
}
.header .nav .title {
  font-size: 34px;
  float:left;
}
.header .nav .cnt {
  font-size:26px;
  float: right;
  padding: 0px;
  margin: 0px;
}
.header .nav .cnt li{
  float:left;
  margin-right: 53px;
}
.header .nav .cnt li a{
  color: white;
}
.header .nav .login-btn{
  background-color: #e15454;
  width: 99px;
  height: 30px;
  border: none;
  border-radius: 5px;
  color: white;
  float:right;
  cursor: pointer;
}
.header .desc{
  margin-top: 63px;
}
.header .desc .d1{
  font-size: 43px;

}
.header .desc .d2,.header .desc .d3{
  font-size:24px;
  line-height: 48px;
}
.header .desc .help-btn{
  margin-top: 20px;
  width: 355px;
  height: 74px;
  background-color: white;
  border: none;
  border-radius: 37px;
  font-size: 24px;
  color: #2f2dd2;
  cursor: pointer;
}
.product{
  margin-top:20px;
}
.product ul li{
  float: left;
  width: 266px;
	height: 291px;
  background-color: #ffffff;
	box-shadow: 0px 0px 8px 2px 
		rgba(38, 38, 178, 0.12);
	border-radius: 8px;
  color:black;
  text-align: center;
  font-size: 20px;
}
.product ul li img{
  margin-top:52px;
}
.product ul li div{
  margin-top:68px;
}
.line{
   background: url("/static/images/index_line.png");
    background-size: 1920px 205px;
    height:205px;
    margin-top:180px;
}
.platform{
  margin-top:46px;
  text-align: center;
  color: white;
}
.platform .efb{
width: 598px;
	height: 312px;
	background-color: #cc4233;
	box-shadow: 0px 0px 10px 1px 
		rgba(25, 25, 220, 0.1);
	border-radius: 8px;
	opacity: 0.8;
  float:left;
}
.platform .ezl{
  width: 598px;
	height: 312px;
	background-color: #5a78bb;
	box-shadow: 0px 0px 10px 1px 
		rgba(25, 25, 220, 0.1);
	border-radius: 8px;
  float: right;
}
.platform .esb{
  	width: 1227px;
	height: 249px;
	background-color: #4398b4;
	box-shadow: 0px 0px 10px 1px 
		rgba(25, 25, 220, 0.1);
	border-radius: 8px;
}
.platform .efb .title,.platform .ezl .title{
  font-size:30px;
  margin-top:86px;
  margin-bottom: 70px;
}
.platform .efb .des,.platform .ezl .des{
 
  font-size: 20px;
  margin-top:10px;
}
.platform .esb .title{
   font-size:30px;
   padding-top:54px;
   text-align: center;
   color: white;
}
.platform .esb ul{
  margin-top:59px;
}
.platform .esb ul li{
  float:left;
  width:305px;
  font-size: 19px;
}

.platform .esb ul a{
  float:left;
  width:305px;
  font-size: 19px;
}

.others{
 
 	width: 957px;
	height: 134px;
	font-family: PingFang-SC-Regular;
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 55px;
	letter-spacing: 0px;
	color: #222283;
  margin: 0 auto;
   margin-top: 81px;

}

.bottom{
  height: 100px;
  width: 100%;
  text-align: center;
  background-color: cadetblue;
  line-height: 100px;
  margin-top: 60px;
}

</style>


// WEBPACK FOOTER //
// src/components/Index.vue